import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { PatientPersonalInfo } from '../models/verifypatient/verifypatient';
import { SavePastHX } from '../models/intake/pastHospitalization';

@Injectable({
  providedIn: 'root'
})
export class PastHospitalizationService {
  
  constructor(private genericService: GenericUtilityService) { }

  getPastHospHX(personalInfo: PatientPersonalInfo){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetPastHospitalization?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  savePastHospHX(data: SavePastHX){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveUpdatePastHospitalization", data);
  }

  deletePastHospHX(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeletePastHospitalization", data);
  }
  noKnownPastHospHistory(personalInfo: PatientPersonalInfo){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownPastHspitalizationForPatient", {PatientAccount: personalInfo.PATIENT_ACCOUNT, PracticeCode: personalInfo.PRACTICE_CODE});
  }
}
